import * as React from 'react';
import { useFiltersContext } from '../../contexts/filters';
import { useSettingsContext } from '../../contexts/settings';
const { __ } = wp.i18n;

const Search = () => {
	const { searchQuery, setSearchQuery } = useFiltersContext();
	const [value, setValue] = React.useState(searchQuery);
	const settings = useSettingsContext();
	React.useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			setSearchQuery(value);
		}, 600);

		return () => clearTimeout(delayDebounceFn);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	React.useEffect(() => {
		if (!searchQuery.length) {
			setValue('');
		}
	}, [searchQuery]);

	const searchParentRef = React.useRef(false);
	const handleOnFocusInput = () => {
		searchParentRef.current.classList.add('pfa-search--focus');
	};

	const handleOnBlurInput = () => {
		searchParentRef.current.classList.remove('pfa-search--focus');
	};

	const handleOnFocusIcon = (e) => {
		e.target.firstChild.classList.add('pfa-search--focus');
	};

	const handleOnBlurIcon = (e) => {
		e.target.firstChild.classList.remove('pfa-search--focus');
	};

	if (settings.showSearch) {
		return (
			<div className="pfa-search">
				<div
					className="pfa-search__wrapper"
					ref={searchParentRef}
					role="region"
					aria-label="search"
				>
					<div htmlFor="pfa-keyword-search" className="sr-only">
						{__(
							'Enter keywords into the search text box to filter blog posts. Results are filtered as you type.',
							'wex'
						)}
					</div>
					<input
						className="pfa-search__input"
						id="pfa-keyword-search"
						type="text"
						value={value}
						onChange={(e) => setValue(e.target.value)}
						placeholder={__('Search by keywords', 'wex')}
						onFocus={() => handleOnFocusInput()}
						onBlur={() => handleOnBlurInput()}
						aria-label={__('Search', 'wex')}
					/>

					{!!value.length ? (
						<button
							className="pfa-search__icon"
							onClick={() => setValue('')}
							onFocus={(e) => handleOnFocusIcon(e)}
							onBlur={(e) => handleOnBlurIcon(e)}
							aria-label="Clear search input"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								height="24"
								viewBox="0 -960 960 960"
								width="24"
								className="pfa-search__icon-close"
							>
								<path
									d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
									fill="#243746"
								/>
							</svg>
						</button>
					) : (
						<button
							className="pfa-search__icon"
							onClick={() => setValue('')}
							tabIndex={-1}
							aria-hidden="true"
							aria-label="Search button"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="17"
								height="16"
								viewBox="0 0 17 16"
								fill="none"
							>
								<path
									d="M15.75 14.7188C16.0625 15.0312 16.0625 15.5 15.75 15.7812C15.625 15.9375 15.4375 16 15.25 16C15.0312 16 14.8438 15.9375 14.6875 15.7812L10.5 11.5938C9.375 12.5 7.96875 13 6.46875 13C2.90625 13 0 10.0938 0 6.5C0 2.9375 2.875 0 6.46875 0C10.0312 0 12.9688 2.9375 12.9688 6.5C12.9688 8.03125 12.4688 9.4375 11.5625 10.5312L15.75 14.7188ZM1.5 6.5C1.5 9.28125 3.71875 11.5 6.5 11.5C9.25 11.5 11.5 9.28125 11.5 6.5C11.5 3.75 9.25 1.5 6.5 1.5C3.71875 1.5 1.5 3.75 1.5 6.5Z"
									fill="#243746"
								/>
							</svg>
						</button>
					)}
				</div>
			</div>
		);
	}

	return '';
};

Search.displayName = 'Search';

export default Search;
